import React, { lazy, Suspense } from "react";

const LazyProjectListing = lazy(() => import("./ProjectListing"));
const LazyViewProject = lazy(() => import("./ViewProject"));
const LazyPrintApartmentShuqa = lazy(() => import("./PrintApartmentShuqa"));

export const ProjectListing = () => (
  <Suspense fallback="loading...">
    <LazyProjectListing />
  </Suspense>
);
export const ViewProject = () => (
  <Suspense fallback="loading...">
    <LazyViewProject />
  </Suspense>
);
export const PrintApartmentShuqa = () => (
  <Suspense fallback="loading...">
    <LazyPrintApartmentShuqa />
  </Suspense>
);
